export default __webpack_public_path__ + "static/media/icon-up.8fd1f4fe.svg";